import { isSignedIn } from 'Util/Auth';
import { getGuestQuoteId } from 'Util/Cart';
import { Field } from 'Util/Query';

/** @namespace AllHomePwafe/Query/ShopByLook/Query/ShopByLookQuery */
export class ShopByLookQuery {
    getSlideList({
        pageSize, currentPage, slide_url, slide_id
    }) {
        const slideQuery = new Field('kmSlides')
            .addArgument('pageSize', 'Int!', pageSize)
            .addArgument('currentPage', 'Int!', currentPage)
            .addArgument('action', 'String!', 'get_slide_list')
            .addFieldList([
                'total_count',
                this._getPageInfoField(),
                new Field('items')
                    .addFieldList([
                        ...this._getSlideItemFields(),
                        this._getRelatedFields()
                    ])
            ]);

        const filter = { is_active: { eq: 1 } };

        if (slide_url) {
            filter.slide_url = { eq: slide_url };
        }

        if (slide_id) {
            filter.slide_id = { eq: slide_id };
        }

        slideQuery.addArgument('filter', 'FilterInput!', filter);

        return slideQuery;
    }

    _getSlideItemFields() {
        return [
            this._getTagImageField(),
            'slide_id',
            'slider_id',
            'slide_url',
            'title',
            'caption',
            'title',
            'image_path',
            'hotspots',
            'link',
            'caption',
            'position',
            'is_active',
            'similar_product_content'
        ];
    }

    _getTagImageField() {
        return new Field('slider')
            .addField(new Field('items')
                .addField(new Field('hotspot_image_path')));
    }

    _getPageInfoField() {
        return new Field('pageInfo')
            .addFieldList(this._getPageInfoFields());
    }

    _getPageInfoFields() {
        return [
            'currentPage',
            'pageSize'
        ];
    }

    _getRelatedFields() {
        return new Field('related')
            .addFieldList([
                'total_count',
                new Field('items').addFieldList(this._getSlideItemFields())
            ]);
    }

    shopTheLookQuery(shopTheLookId) {
        const query = new Field('kmShopTheLook')
            .addArgument('shopTheLookId', 'String!', shopTheLookId)
            .addFieldList(['message', 'type']);

        if (!isSignedIn()) {
            query.addArgument('guestCartId', 'String', getGuestQuoteId());
        }

        return query;
    }
}

export default new ShopByLookQuery();
